import c from 'clsx'
import React, { forwardRef, ReactNode, useMemo } from 'react'
import { XTEXT_DECORATIONS, XTEXT_MARGINS, XTEXT_SIZE } from 'v2/styles/constants'
import styles from './style.module.scss'

interface Props {
    children: string | ReactNode
    size?: string
    color?: string
    type?: string
    decorator?: string
    margins?: string
    alignment?: string
    onMouseDown?: (event: any) => void
    onClick?: (event: any) => void
    ellipsis?: boolean
    wrapText?: boolean
    style?: React.CSSProperties
}

const XText = forwardRef<any, Props>((props: Props, ref) => {
    const { children, onMouseDown, onClick } = props

    const dangerousInnerHtml = useMemo(() => {
        if (typeof children === 'string') {
            return {
                dangerouslySetInnerHTML: { __html: children.toString() },
            }
        }
        return {}
    }, [children])

    const usesDangerousInnerHtml = useMemo(() => {
        return typeof children === 'string'
    }, [children])

    const ellipsisStyle: React.CSSProperties = props.ellipsis
        ? { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }
        : {}

    const textWrapStyle: React.CSSProperties = props.wrapText
        ? { whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }
        : {}

    const extraStyles = props.style || {}

    return (
        <React.Fragment>
            {usesDangerousInnerHtml && (
                <p
                    ref={ref}
                    onMouseDown={onMouseDown}
                    onClick={onClick}
                    className={c(
                        styles.xtext,
                        styles[props.size || XTEXT_SIZE.MEDIUM],
                        styles[props.decorator || XTEXT_DECORATIONS.REGULAR],
                        styles[props.margins || XTEXT_MARGINS.DEFAULT],
                        styles[props.alignment],
                        styles[props.type]
                    )}
                    style={{ color: props.color, ...ellipsisStyle, ...textWrapStyle, ...extraStyles }}
                    {...dangerousInnerHtml}
                ></p>
            )}
            {!usesDangerousInnerHtml && (
                <div
                    ref={ref}
                    onMouseDown={onMouseDown}
                    onClick={onClick}
                    className={c(
                        styles.xtext,
                        styles[props.size || XTEXT_SIZE.MEDIUM],
                        styles[props.decorator || XTEXT_DECORATIONS.REGULAR],
                        styles[props.margins || XTEXT_MARGINS.DEFAULT],
                        styles[props.alignment],
                        styles[props.type]
                    )}
                    style={{ color: props.color, ...ellipsisStyle, ...textWrapStyle }}
                >
                    {children}
                </div>
            )}
        </React.Fragment>
    )
})

XText.displayName = 'XText'

export default XText
